import React from 'react';
import PropTypes from 'prop-types';
import { Button} from '@mui/material';
import {
    createOrderWithCredits
} from "../../axios-client";
import { useTranslation } from "react-i18next";

const CreditsPaymentButton = ({
                                  articleId,
                                  refreshList,
                                  setNotification,
                                  processIds
                              }) => {

    const { t } = useTranslation("publicationsTranslation");                               
    const handleClick = async () => {
        try {
            await createOrderWithCredits(processIds, 'yaiglobal_credit');
            setNotification({
                show: true,
                snackbarMessage: t("paymentSuccess"),
                severity: 'success',
            });
            window.location.reload();
        } catch (error) {
            console.error('Payment process error:', error);
            setNotification({
                show: true,
                snackbarMessage: t("paymentError"),
                severity: 'error',
            });
        }
    };

    return (
        <Button
            fullWidth
            variant="contained"
            style={{
                background: "linear-gradient(45deg, #0070ba 30%, #003087 90%)",
                color: "#fff",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                fontWeight: 500,
                height:40,
                py: 1.2,
                marginTop:"0px !important",
                fontSize: "0.8rem",
                backdropFilter: "blur(4px)",
                "&:hover": {
                    background: "linear-gradient(45deg, #005ea6 30%, #002973 90%)",
                    boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
                },
                textTransform:"capitalize"
            }}
            onClick={handleClick}
        >
            <span style={{fontSize: "13px", fontWeight: "bold", color: "white"}}>{t("useCredits")}</span>
        </Button>
    );
}
CreditsPaymentButton.propTypes = {
    articleId: PropTypes.number.isRequired,
    setNotification: PropTypes.func.isRequired,
    refreshList: PropTypes.func,
    processIds: PropTypes.array
};

export default CreditsPaymentButton;